import React from 'react';
import { Button } from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';

import { MediaUploader as MediaUploaderView } from '../../../ui';
import { UploadedMediaType } from '../../MediaUploader/types';
import { UploadFile } from 'antd/lib/upload/interface';

interface MediaUploaderProps {
  id: string;
  name: string;
  placeholder: string;
  imageOnly?: boolean;
  withVideo?: boolean;
  pictureListType: 'picture-card' | 'picture';
  defaultValue: Array<UploadFile>;
  limit?: number;
  onUpload: (mediaList: Array<UploadedMediaType>) => void;
  canRemove?: boolean;
  isDisabled?: boolean;
}

export const MediaUploader: React.FC<MediaUploaderProps> = ({
  id,
  name,
  placeholder,
  defaultValue,
  pictureListType,
  limit,
  imageOnly,
  withVideo,
  onUpload,
  canRemove,
  isDisabled,
}) => {
  const children =
    name === 'avatar' || name === 'coverGroup' ? (
      <Button
        id={`${id}-button`}
        disabled={isDisabled}
        icon={<UploadOutlined />}
      >
        {placeholder}
      </Button>
    ) : (
      <PlusOutlined id={`${id}-plus-icon`} />
    );

  const props = {
    id,
    limit,
    placeholder,
    pictureListType,
    imageOnly,
    withVideo,
    onUpload,
    defaultValue,
    canRemove,
    isDisabled,
  };

  return <MediaUploaderView {...props}>{children}</MediaUploaderView>;
};
